import Loader from "@/components/ui/loader-4";

type AppLoaderProps = {
  label?: string;
  size?: number;
  className?: string;
};

export const AppLoader = ({ label = "Loading Orizonte...", size = 16, className = "" }: AppLoaderProps) => (
  <div className={`flex flex-col items-center justify-center text-center ${className}`}>
    <Loader size={size} />
    {label ? <p className="mt-4 text-sm text-orizonte-textMuted">{label}</p> : null}
  </div>
);
